import axiosInstance from "../lib/axiosInstance";

export const getProfile = async () => {
    const response = await axiosInstance.get("api/student/profile/getProfile");
    return response.data;
};
export const editProfile = async (payload) => {
    const response = await axiosInstance.put("api/student/profile/editProfile", payload);
    return response.data;
};
export const createProfile = async (payload) => {
    const response = await axiosInstance.post("api/student/profile/create", payload);
    return response.data;
};

export const uploadFile = async (formData) => {
  return await axiosInstance.post("/common/s3/uploadFile", formData, {
        headers: {
            "Content-Type": "multipart/form-data", // allow axios to set proper boundaries
        },
    });
};

/**
 * Send verification OTP to email or mobile from student profile
 * @param {string} type - "EMAIL" or "MOBILE"
 */
export const sendVerificationOtp = async (type) => {
    const response = await axiosInstance.post("api/student/profile/sendVerificationOtp", { type });
    return response.data;
};

/**
 * Verify OTP and mark email or mobile as verified
 * @param {string} type - "EMAIL" or "MOBILE"
 * @param {string} otp - OTP entered by user
 */
export const verifyProfileOtp = async (type, otp) => {
    const response = await axiosInstance.post("api/student/profile/verifyOtp", { type, otp });
    return response.data;
};
